// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"c28fb891","856":"a51f60a4"}[chunkId] + ".js";
};